// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-feel-good-chemical.svg';

export const MindBodyFeelGoodChemical = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
